import { io } from 'socket.io-client';

import socketBaseUrl from './socketBaseUrl';

const skuEbayDataSyncSocket = io(`${socketBaseUrl}/sku-ebay-data-sync`, {
  transports: ['websocket'],
  autoConnect: false,
});

export default skuEbayDataSyncSocket;
